"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _Context = _interopRequireDefault(require("../Context"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/** High order component, it inserts the `featureFlag` and `variant` props.
 * It also triggers `window.isVariantEnabled` on client side when the decorated component is mounted.
 *
 * @param {String} featureFlag - Experiment name
 * @return {Function} Component Decorator
 */
function withFeatureFlag(featureFlag) {
  featureFlag = featureFlag.toUpperCase();
  return Component => {
    class BaseWithExperiment extends _react.default.Component {
      componentDidMount() {
        const {
          featureFlag,
          __isFeatureEnabled
        } = this.props;
        if (!featureFlag) return;
        if (featureFlag) {
          __isFeatureEnabled(featureFlag);
          return;
        }
      }
      render() {
        const {
          __isFeatureEnabled,
          ...props
        } = this.props; // eslint-disable-line no-unused-vars
        return /*#__PURE__*/_react.default.createElement(Component, props);
      }
    }
    BaseWithExperiment.propTypes = {
      featureFlag: _propTypes.default.string,
      __isFeatureEnabled: _propTypes.default.func.isRequired
    };
    class withFeatureFlag extends _react.default.Component {
      constructor(...args) {
        super(...args);
        this.child = ({
          featureFlags,
          isFeatureEnabled
        }) => {
          const enabled = featureFlags[featureFlag];
          return /*#__PURE__*/_react.default.createElement(BaseWithExperiment, _extends({}, this.props, {
            featureFlag: enabled ? featureFlag : undefined,
            __isFeatureEnabled: isFeatureEnabled
          }));
        };
      }
      render() {
        return /*#__PURE__*/_react.default.createElement(_Context.default.Consumer, null, this.child);
      }
    }
    withFeatureFlag.displayName = `withFeatureFlag(${featureFlag})(${Component.displayName || Component.name})`;
    return (0, _hoistNonReactStatics.default)(withFeatureFlag, Component);
  };
}
var _default = withFeatureFlag;
exports.default = _default;